import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
import DealerAdIframe from '../dealer';
const DesktopDevPageSide300x250Atf = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Freestar, ADUNIT_MAP['DesktopDevPageSide300x250AtfGam'], safety, {
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '300px',
                height: '600px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['DesktopDevPageSide300x250AtfGam'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
